/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type PostWebTomarkdownAsyncRequest = { url: string };

export const PostWebTomarkdownAsyncRequest$zodSchema: z.ZodType<
  PostWebTomarkdownAsyncRequest
> = z.object({
  url: z.string().describe("需要转换的网页URL。URL必须经过编码。"),
});

/**
 * 请求参数错误
 */
export type PostWebTomarkdownAsyncBadRequestResponseBody = {
  error?: string | undefined;
  message?: string | undefined;
  code?: number | undefined;
};

export const PostWebTomarkdownAsyncBadRequestResponseBody$zodSchema: z.ZodType<
  PostWebTomarkdownAsyncBadRequestResponseBody
> = z.object({
  code: z.int().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
}).describe("请求参数错误");

/**
 * 任务已提交成功，返回任务ID
 */
export type PostWebTomarkdownAsyncResponseBody = {
  task_id?: string | undefined;
  status?: string | undefined;
  url?: string | undefined;
  created_at?: string | undefined;
  message?: string | undefined;
};

export const PostWebTomarkdownAsyncResponseBody$zodSchema: z.ZodType<
  PostWebTomarkdownAsyncResponseBody
> = z.object({
  created_at: z.string().optional(),
  message: z.string().optional(),
  status: z.string().optional(),
  task_id: z.string().optional(),
  url: z.string().optional(),
}).describe("任务已提交成功，返回任务ID");

export type PostWebTomarkdownAsyncResponse =
  | PostWebTomarkdownAsyncResponseBody
  | PostWebTomarkdownAsyncBadRequestResponseBody;

export const PostWebTomarkdownAsyncResponse$zodSchema: z.ZodType<
  PostWebTomarkdownAsyncResponse
> = z.union([
  z.lazy(() => PostWebTomarkdownAsyncResponseBody$zodSchema),
  z.lazy(() => PostWebTomarkdownAsyncBadRequestResponseBody$zodSchema),
]);
